<template>
  <div class="promote-box" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div
      style="
        display: flex;
        width: 100%;
        padding-bottom: 10px;
        margin-bottom: 10px;
        align-items: center;
      "
    >
      <img class="titile-logo" src="@/assets/images/titile-logo.png" alt="" />
      <div class="promote-title">友情链接</div>
      <img
        @click="handleJump()"
        style="padding-left: 30px; cursor: pointer"
        src="@/assets/images/toucu-logo.png"
      />
      <span @click="handleJump()">云南投资促进网</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenIndexWidth: null,
    };
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
  },
  methods: {
    handleJump() {
      window.open("https://invest.yn.gov.cn/");
    },
  },
};
</script>

<style scoped>
.promote-box {
  width: calc(100% - 20px);
  height: 100%;
  margin: 0 10px;
  padding: 0 10px;
}
.promote-title {
  padding-left: 10px;
  /* width: 100%; */
  /* padding-bottom: 10px; */
  /* margin-bottom: 10px; */
  /* border-bottom: 1px solid #acacac; */
  font-size: 1.25rem;
  font-weight: 600;
}
.promote-box span {
  color: #7d7d7d;
  font-size: 0.85rem;
  padding-left: 8px;
  cursor: pointer;
}
</style>